var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.5@core-js/library/modules/_cof.js
// module id = 74
// module chunks = 0